import { render } from "./WhiteNoisePrivacyPolice.vue?vue&type=template&id=520dbf7c"
import script from "./WhiteNoisePrivacyPolice.vue?vue&type=script&lang=js"
export * from "./WhiteNoisePrivacyPolice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__